import React from "react";
import { Button } from "react-native-paper";
import { useAppDispatch } from "../redux/store";
import { logOutAction } from "../redux/slices/authSlice";
import { auth, signOut } from "../firebase";
import { useTranslation } from "react-i18next";

type LogoutButtonProps = {
  style?: object;
};

const LogoutButton: React.FC<LogoutButtonProps> = ({ style }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const logOut = async () => {
    try {
      dispatch(logOutAction());
      await signOut(auth);
      console.log("User logged out successfully");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <Button testID="logout" mode="contained" style={style} onPress={logOut}>
      {t("Log out")}
    </Button>
  );
};

export default LogoutButton;
